import { color, lighten } from "metabase/lib/colors";
export const DefaultSearchColor = lighten(color("nav"), 0.07);
